import { Box, Skeleton } from "@mui/material";

import styles from "./styles";

const WeeklyConsistencyChallengeLoading = () => {
  return (
    <Box sx={styles.card(false)}>
      {/* Header row skeleton */}
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px", mb: 2 }}>
        <Skeleton variant="circular" width={48} height={48} />
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Skeleton variant="text" width={220} height={24} />
          </Box>
          <Skeleton variant="text" width="80%" height={18} sx={{ mt: 0.5 }} />
        </Box>
      </Box>

      {/* Info box skeleton */}
      <Skeleton
        variant="rounded"
        width="100%"
        height={72}
        sx={{ borderRadius: "10px", mb: 2 }}
      />

      {/* This week's progress skeleton */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mb: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Skeleton variant="text" width={150} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </Box>
        <Skeleton variant="text" width={180} height={16} />
        <Skeleton
          variant="rounded"
          width="100%"
          height={10}
          sx={{ borderRadius: "9999px" }}
        />
      </Box>

      {/* Consecutive weeks skeleton */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px", mb: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Skeleton variant="text" width={140} height={20} />
          <Skeleton variant="text" width={80} height={20} />
        </Box>
        <Skeleton
          variant="rounded"
          width="100%"
          height={10}
          sx={{ borderRadius: "9999px" }}
        />
      </Box>

      {/* Week cards skeleton */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: "8px", mb: 2 }}>
        {[1, 2, 3, 4].map((i) => (
          <Skeleton
            key={i}
            variant="rounded"
            sx={{
              flex: { xs: "0 0 calc(50% - 6px)", md: "0 0 calc(25% - 6px)" },
              height: "64px",
              borderRadius: "10px",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default WeeklyConsistencyChallengeLoading;
